import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed } from 'vue';
import CookieService from '@/core/cookie.service';

export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateOrProfessionalSelector',
  setup(__props) {

const modes = computed<IMode[]>(() => store.getters['app/modes']);

function setSiteMode(mode: IMode) {
    CookieService.setSiteMode(mode.id);
    window.location.href = mode.frontpageUrl;
}

return { __sfc: true,modes, setSiteMode }
}

})